(function(){
  Pegasus.SavedImagesController = Em.Controller.extend({
    needs: ['imageGallery', 'frameCommManager', 'upload'],
    staggerResults: true,
    breakValue: 3,
    request: function(query, page, count) {
      var params = [
        'page_number=' + page,
        'page_size=' + count
      ];

      var baseURL = '/saved_image_search.json?';

      if ( query ) {
        params.unshift( query );
        baseURL = '/saved_image_search.json?query=';
      }

      this.get('controllers.frameCommManager').requestSavedImagesFor(
        baseURL + params.join('&'), this
      );
    },
    didCompleteRequest: function(data){
      Em.run( this.get('controllers.imageGallery'), 'send', 'didRetrieveImages', data, this);
    },
    didFailRequest: function(err){
    },
    deleteUserImageRequested: function(content){
      this.send('deleteSavedImage', content );
    },
    didSelectImage: function(view){
      var id = parseInt(
        view.get('content.src').split(/\/images\//).get('lastObject'),
        10
      );

      this.get('controllers.frameCommManager').touchSavedImage( id );
    },

    useThis: function(view){
      var content = view.get('content');
      var src;

      src = content.src;

      this.set('controllers.upload.dataSrcProxy', src);
      this.get('controllers.upload').send('didReplaceImage');
    },

    sizeContent: function(view){
      var actual = $('<img src="' + view.get('content.src') + '" />');

      if ( !view.get('content.naturalWidth') ) {
        actual.imagesLoaded().
          done(function(img){
            Em.run.next(img, function(){
              try {
                view.set('content.naturalWidth', this.images[0].img.naturalWidth);
                view.set('content.naturalHeight', this.images[0].img.naturalHeight);
              }catch(e){}
            });
          }).
          fail(function(img){
            alert('fail');
          });
      }
    }
  });
})();
